// extracted by mini-css-extract-plugin
export default {"form":"faq-category-form-modal_form__R1vfg","visibilityRow":"faq-category-form-modal_visibilityRow__aR22+"};